// JOBE-0044.14: pure variant-selector for /library's load/error region.
//
// Signature pinned by JOBE-0044.14 spec §"Component placement":
//   pickVariant({ loadState, items, removableChips, cacheHit, entityTypesCtx })
//     → 'skeleton' | 'empty' | 'filter-empty' | 'unreachable' | 'cedar-denied' | 'ready' | 'error'
//
// Inputs are framework-free so the table-driven tests in
// pickVariant.test.js can exercise every input combination without a
// React mount.
//
// Precedence (per spec §State machine):
//   - `loading` with no prior rows → skeleton.
//   - `error` with cache hit → unreachable (cached banner + rows).
//   - `error` without cache → error (hard-error panel; sixth variant
//     spec carries for state-machine completeness).
//   - `ready` and rows.length > 0 → ready (happy path).
//   - `ready` and rows.length === 0 + cedarDeniedDetect (requires
//     entityTypesCtx.status === 'ready') → cedar-denied.
//   - `ready` and rows.length === 0 + ≥1 removable chip → filter-empty.
//   - `ready` and rows.length === 0 + no chips → empty (cold start).

import { isCedarDenied } from './cedarDeniedDetect.js';

export function pickVariant({
  loadState,
  items,
  removableChips,
  cacheHit,
  entityTypesCtx,
}) {
  const rows = Array.isArray(items) ? items : [];
  const chipCount = typeof removableChips === 'number' ? removableChips : 0;

  if (loadState === 'loading' && rows.length === 0) {
    return 'skeleton';
  }
  if (loadState === 'error') {
    return cacheHit ? 'unreachable' : 'error';
  }
  if (loadState === 'ready') {
    if (rows.length > 0) return 'ready';
    // Empty page; pick among cedar-denied / filter-empty / empty.
    if (
      chipCount === 0
      && isCedarDenied({
        entitiesItems: rows,
        entityTypesCtx,
        removableChips: chipCount,
      })
    ) {
      return 'cedar-denied';
    }
    if (chipCount > 0) return 'filter-empty';
    return 'empty';
  }
  // idle or any other state — render skeleton as a safe default so we
  // never blank-flash. The page is "never blank then populated" per R11.
  return 'skeleton';
}
